import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import ProductFiltering from "Vue/containers/ProductFiltering.vue";

const routes: Array<RouteRecordRaw> = [
	{
		path: '/products',
		name: "Products",
		component: ProductFiltering,
		props: true
	},
	{
		path: '/sc/:category',
		name: "Container",
		component: ProductFiltering,
		props: true
	},
]



const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;
